import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Industry from './Industry';
import Tabs from '../Tabs';
import LanguageLevels from './LanguageLevels';
import Languages from './Languages';
import classes from './styles.module.scss';
import WorkShifts from './WorkShifts';

export default function RefDataManagement() {
  const [industryCount, setIndustryCount] = useState(0);
  const [languageLevelCount, setLanguageLevelCount] = useState(0);
  const [languageCount, setLanguageCount] = useState(0);
  const [workShiftCount, setWorkShiftCount] = useState(0);

  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState('tab1-industry');
  const tabs = [
    {
      id: 'tab1-industry',
      label: t('dashboardComponents.Console.RefDataManagement.industry'),
    },
    {
      id: 'tab1-languageLevel',
      label: t('dashboardComponents.Console.RefDataManagement.languageLevel'),
    },
    {
      id: 'tab1-language',
      label: t('dashboardComponents.Console.RefDataManagement.language'),
    },
    {
      id: 'tab1-workShift',
      label: t('dashboardComponents.Console.RefDataManagement.workShift'),
    },
  ];

  return (
    <div className={classes.RefDataManagement}>
      <Tabs
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        name="refData"
        tabs={tabs}
        countData={{
          'tab1-industry': industryCount,
          'tab1-languageLevel': languageLevelCount,
          'tab1-language': languageCount,
          'tab1-workShift': workShiftCount,
        }}
      />
      <div className={classes.container}>
        <div
          style={{
            display: currentTab === 'tab1-industry' ? 'block' : 'none',
          }}
        >
          <Industry setItemCount={setIndustryCount} />
        </div>
        <div
          style={{
            display: currentTab === 'tab1-languageLevel' ? 'block' : 'none',
          }}
        >
          <LanguageLevels setItemCount={setLanguageLevelCount} />
        </div>
        <div
          style={{
            display: currentTab === 'tab1-language' ? 'block' : 'none',
          }}
        >
          <Languages setItemCount={setLanguageCount} />
        </div>
        <div
          style={{
            display: currentTab === 'tab1-workShift' ? 'block' : 'none',
          }}
        >
          <WorkShifts setItemCount={setWorkShiftCount} />
        </div>
      </div>
    </div>
  );
}
